import React, { useRef } from 'react';
import LinkPreviewCard from './LinkPreviewCard';

const LinkCarousel = ({ links }) => {
    const scrollRef = useRef(null);

    if (!links || links.length === 0) return null;

    return (
        <div
            className="link-carousel-container"
            style={{
                marginTop: '12px',
                width: '100%',
                position: 'relative'
            }}
        >
            <div
                ref={scrollRef}
                style={{
                    display: 'flex',
                    overflowX: 'auto',
                    paddingBottom: '8px', // Space for scrollbar if visible, or visual breathing room
                    paddingLeft: '4px', // Visual offset
                    paddingRight: '4px',
                    scrollbarWidth: 'none', // Firefox
                    msOverflowStyle: 'none', // IE/Edge
                    WebkitOverflowScrolling: 'touch',
                    cursor: 'grab'
                }}
                // Hiding scrollbar for Webkit
                className="no-scrollbar"
            >
                <style>
                    {`
                .no-scrollbar::-webkit-scrollbar {
                    display: none;
                }
            `}
                </style>

                {links.map((link, index) => (
                    <LinkPreviewCard key={index} link={link} />
                ))}
            </div>
        </div>
    );
};

export default LinkCarousel;
